export default {
  seeMoreText: 'Ver más',
};
